export const SET_WIDTH_ITEMS_ARRAY = 'SET_WIDTH_ITEMS_ARRAY'
